import { Pipe } from '@angular/core';

@Pipe({
    name: 'reverse',
    pure: true
})
export class ReversePipe {
    public transform(values) {
        if (values) {
            return values.reverse();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/reverse.pipe.ts